import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

const getRestBaseEndpoint = () => {
    //getDeployOptions() doesnt seem to be working
    const options = (window as any).__DEPLOY_OPTIONS;
    return options.restApiUrl;
};

const axiosInstance: AxiosInstance = axios.create({
    baseURL: getRestBaseEndpoint(),
});

const attachTokenToRequest = (config: AxiosRequestConfig) => {
    let localStorageVal = localStorage.getItem("quipa-store");
    const parsedVal = localStorageVal ? JSON.parse(localStorageVal) : null;

    if (parsedVal && parsedVal.user) { // NOSONAR
        //current typescript version doesnt support optional chaining, hence NOSONAR above
        const { token } = parsedVal.user;
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
};

axiosInstance.interceptors.request.use(attachTokenToRequest);

export default axiosInstance;
